import styled from 'styled-components';

export const TabList = styled.ol(
	props => `
		padding: 2px;
		align-items: center;
		display: inline-flex;
		background-color: #ffffff;
		border-radius: 15px;
		color: #647a97;
		border-radius: 30px;
		box-shadow: 0 2px 5px 0 rgb(0 0 0 / 50%);
	`
);

export const TabListItem = styled.li(
	props => `
		cursor: pointer;
		padding: 6px 16px;
		list-style: none;
	`
)

export const TabItemContainer = styled.div(
	props => `
		padding: 2px;
		align-items: center;
		display: inline-flex;
		background-color: #ffffff;
    border-radius: 15px;
    color: #647a97;
    border-radius: 30px;
    box-shadow: 0 2px 5px 0 rgb(0 0 0 / 50%);
	`
)